///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createBrowserHistory } from "history";

let history;

const getUserConfirmation = (message, callback) => {
  //Callback takes in true or false:
  //True to perform the blocked naviagtion
  //False to permanently block it
  history.resolveBlock = callback;
};

export const getHistory = options => {
  if (!history) {
    history = createBrowserHistory({ ...options, getUserConfirmation });
  }

  return history;
};

export default getHistory;
